import { useCallback, useEffect, useRef, useState } from 'react'

export const useTriggerRerender = (
  interval = 1000,
  enabledByDefault = true,
) => {
  const timerId = useRef<ReturnType<typeof setInterval>>()
  const [timer, forceUpdate] = useState(0)
  const inititated = timerId.current

  const startTimer = useCallback(() => {
    timerId.current = setInterval(() => {
      forceUpdate((prev) => prev + interval)
    }, interval)
  }, [interval])

  const stopTimer = useCallback(() => {
    if (timerId.current) {
      clearInterval(timerId.current)
    }
  }, [])

  useEffect(() => {
    if (enabledByDefault) {
      startTimer()
    }

    return stopTimer
  }, [enabledByDefault, startTimer, stopTimer])

  return {
    startTimer,
    stopTimer,
    timer,
    inititated,
  }
}
